<template>
  <v-container fluid class="invoice-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Invoice</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Invoice</p>
                        <v-select
                          class="mb-4"
                          :items=invoicetype
                          v-model="new_invoice.invoicetype"
                          v-bind:error="error == 'invoicetype'"
                          v-on:change="clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the invoice type">
                        </v-select>
                        <v-menu
                          ref="menu_invoicedate"
                          v-model="menu_invoicedate"
                          :close-on-content-click="false"
                          :return-value.sync="new_invoice.invoicedate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-2"
                              outlined
                              dense
                              v-model="new_invoice.invoicedate"
                              label="Invoice Date"
                              v-bind="attrs"
                              v-bind:value="new_invoice.invoicedate"
                              v-bind:error="error == 'invoicedate'"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please choose the invoice date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_invoice.invoicedate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_invoicedate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_invoicedate.save(new_invoice.invoicedate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_invoiceduedate"
                          v-model="menu_invoiceduedate"
                          :close-on-content-click="false"
                          :return-value.sync="new_invoice.invoiceduedate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_invoice.invoiceduedate"
                              label="Invoice Due Date"
                              v-bind="attrs"
                              v-bind:value="new_invoice.invoiceduedate"
                              v-bind:error="error == 'invoiceduedate'"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please choose the invoice due date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_invoice.invoiceduedate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_invoiceduedate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_invoiceduedate.save(new_invoice.invoiceduedate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          append-icon="mdi-magnify"
                          placeholder="Customer Name"
                          single-line hint="Select the Customer"
                          outlined
                          dense
                          readonly
                          @click:append="searchCustomerDialog"
                          persistent-hint
                          v-model="new_invoice.invoicename"
                          v-bind:error="error == 'customerid'"
                        >
                        </v-text-field>      
                        <v-textarea
                          v-model="new_invoice.invoiceaddress"
                          v-bind:error="error == 'invoiceaddress'"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the customer address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="new_invoice.invoicephone"
                          v-bind:error="error == 'invoicephone'"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="new_invoice.locationid"
                          v-bind:error="error == 'locationid'"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="paymethods.map(x => {
                            return {text: x.paymethodname, value: x._id};
                            })"
                          v-model="new_invoice.paymethodid"
                          v-bind:error="error == 'paymethodid'"
                          outlined
                          dense
                          placeholder="Pay Method"
                          persistent-hint
                          single-line hint="Please choose the pay method">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=invoicepayterms
                          v-model="new_invoice.invoicepayterms"
                          v-bind:error="error == 'invoicepayterms'"
                          outlined
                          dense
                          placeholder="Pay Terms"
                          persistent-hint
                          single-line hint="Please choose the pay terms">
                        </v-select>
                      </v-form>
                    </v-col>         
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_invoice.refnum"
                          v-bind:error="error == 'refnum'"
                          outlined
                          dense
                          placeholder="Ref Num"
                          persistent-hint
                          single-line hint="Enter the reference">
                        </v-text-field>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-2"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_invoice.primaryCurrency"
                              v-bind:error="error == 'primaryCurrency'"
                              outlined
                              dense
                              placeholder="Currency 1"
                              persistent-hint
                              single-line hint="Currency 1">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-2"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_invoice.secondaryCurrency"
                              v-bind:error="error == 'secondaryCurrency'"
                              outlined
                              dense
                              placeholder="Currency 2"
                              persistent-hint
                              single-line hint="Currency 2">
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-text-field
                          class="mb-4"
                          v-model="new_invoice.currencyRate"
                          v-bind:error="error == 'currencyRate'"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                        <v-textarea
                          v-model="new_invoice.invoicenote"
                          outlined
                          dense
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                               
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/invoice/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="header_item"
                    :items="transactions"
                    :items-per-page="100"
                    class="elevation-0"
                  >
                    <template v-slot:item.accountid="{ item }">
                      {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="primary" @click="editTransactionDialog(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="deleteTransaction(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertInvoice()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2 && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog
      v-model="isSearchCustomer"
      persistent
      scrollable
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-container>
            <v-row>
              <span class="text-h5" style="padding:10px">Search Customer</span>
            </v-row>

          <v-row>
            <v-col cols="12" md="4">
                <v-form>
                  <v-text-field
                    class="mb-4"
                    append-icon="mdi-magnify"
                    @click:append="searchCustomer"
                    v-model="search_customer.searchtext"
                    outlined
                    dense
                    placeholder="Search"
                    persistent-hint
                    single-line hint="Search customer"
                  >
                  </v-text-field>
                </v-form>
              </v-col>
          </v-row>
          </v-container>

        </v-card-title>
        <v-card-text style="height: 400px;">
          <v-container>
            <v-row>

              <v-col cols="12" md="12">
                <v-data-table
                  :items-per-page="100"
                  :headers="header_customer"
                  :items="searches"
                  item-value="name"
                >
                <template v-slot:item.customerimage="{ item }">
                  <img v-if="item.customerimage" v-bind:src="item.customerimage" alt="" width="80">
                </template>
                <template v-slot:item.customername="{ item }">
                  <a class="primaryConst--text">{{ item.customername }}</a>
                  <p>{{ item.customertype }}</p>
                </template>
                <template v-slot:item.customeraddress="{ item }">
                  <a class="primaryConst--text">{{ item.customeraddress }}</a>
                  <p class="two-line">{{ item.customerphone  }}</p>
                  <p class="two-line">{{ item.customermobile  }}</p>
                </template>
                <template v-slot:item.townshipid="{ item }">
                  <p class="two-line">{{ item.countryid!=undefined && countries.find(country=>country._id == item.countryid)!=null ? countries.find(country=>country._id == item.countryid)['countryname'] : ''   }}</p>
                  <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                </template>
                <template v-slot:item.customerstatus="{ item }">
                  <v-chip
                    :color="!item.customerstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                    small>
                    {{ item.customerstatus }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div v-if="item._id!=undefined">
                  <v-btn icon color="primary" @click="selectCustomer(item)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  </div>
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isSearchCustomer = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_item: [
        { text: 'Account', value: 'accountid' },
        { text: 'Description', value: 'itemdesc', width: '30%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_customer: [
        { text: 'Image', value: 'customerimage', sortable: false },
        { text: 'Name', value: 'customername' },
        { text: 'Address', value: 'customeraddress' },
        { text: 'Location', value: 'townshipid' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      transactions: [],
      searches: [],
      sheet: false,
      isSearchCustomer: false,
      isAddTransaction: false,
      isEditTransaction: false,
      accountid: null,

      step: 1,
      new_invoice: {},
      new_transaction: {},
      edit_transaction: {},
      search_customer: {},
      accountsubclass: null,
      accountsubclass2: null,
      menu_invoicedate: false,
      menu_invoiceduedate: false,

      invoicetype: ['Service Invoice'],
      invoicepayterms: ['Cash', 'Credit 5 Days', 'Credit 15 Days', 'Credit 30 Days', 'Due on Receipt'],


      error: null,
      haserror: false,
      errorindex: undefined,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      isTaxable: false,
      taxRate: null,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Brand', ['brands']),
    ...mapState('Customer', ['customers']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('Country', ['countries']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('Township', ['townships']),
    ...mapState('Invoice', ['isReceiving']),
    ...mapState('User', ['users']),
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass=='Revenue');
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return [...result];
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Customer', ['getCustomersRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('PayMethod', ['getPayMethodsRequest']),
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions('Invoice', ['getInvoices', 'insertInvoiceRequest']),
    ...mapActions('Search', ['searchCustomerRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('Township', ['getTownshipsRequest']),
    ...mapActions('User', ['getUsersRequest']),
    checkError(){
      if(!this.new_invoice.invoicetype){
        this.error = 'invoicetype';
        return false;
      }
      if(!this.new_invoice.invoicedate){
        this.error = 'invoicedate';
        return false;
      }
      if(!this.new_invoice.customerid){
        this.error = 'customerid';
        return false;
      }
      if(!this.new_invoice.locationid){
        this.error = 'locationid';
        return false;
      }
      if(!this.new_invoice.refnum){
        this.error = 'refnum';
        return false;
      }
      if(!this.new_invoice.paymethodid){
        this.error = 'paymethodid';
        return false;
      }
      if(!this.new_invoice.invoicepayterms){
        this.error = 'invoicepayterms';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(!this.checkTransaction()) return;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.isAddTransaction = false;
      this.clearFields();
    },
    clearFields(){
      this.new_transaction = {};
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertInvoice() {
      let payload = {invoice: this.new_invoice, transactions: this.transactions};
      await this.insertInvoiceRequest(payload);
      router.push('/invoice/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    editTransactionDialog(item){
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    searchCustomerDialog(){
      this.search_customer = {};
      this.isSearchCustomer = true;
    },
    selectCustomer(item){
      this.new_invoice.invoicename = item.customername;
      this.new_invoice.invoiceaddress = item.customeraddress;
      this.new_invoice.invoicephone = item.customerphone;
      this.new_invoice.invoicemobile = item.customermobile;
      this.new_invoice.customertype = item.customertype;
      this.new_invoice.customerid = item._id;
      this.new_invoice.countryid = item.countryid;
      this.new_invoice.townshipid = item.townshipid;
      this.isSearchCustomer = false;
    },
    async searchCustomer(){
      console.log(this.search_customer)
      let results = await this.searchCustomerRequest(this.search_customer);
      this.searches = results;
    }
  },

  async created () {
    let params = this.$route.params;
    if(params!=null){
      this.new_invoice = Object.assign({}, params);
      delete this.new_invoice['invoicedate'];
      delete this.new_invoice['invoiceduedate'];
      delete this.new_invoice['invoicestatus'];
      this.transactions = Object.assign([], params.transactions);
      for(var item of this.transactions){
        item['id'] = item['_id'];
        delete item['_id'];
        delete item['transdate'];
      }
    }

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.countries.length==0) await this.getCountriesRequest();
    if(this.customers.length==0) await this.getCustomersRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.paymethods.length==0) await this.getPayMethodsRequest();

    if(this.settings.length==0) await this.getSystemSettingsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    this.primaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    this.secondaryCurrency = this.primaryCurrency;
    this.currencyRate = 1;
    
    this.isDualCurrency = this.primaryCurrency!=null && this.secondaryCurrency!=null ? (this.primaryCurrency!=this.secondaryCurrency) : false;
    this.new_invoice.primaryCurrency = this.primaryCurrency;
    this.new_invoice.secondaryCurrency = this.secondaryCurrency;
    this.new_invoice.currencyRate = this.currencyRate;
    this.new_invoice.isDualCurrency = this.isDualCurrency;
    
    this.isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    this.taxRate = await this.getSetting({code: 'TaxSettings', name: 'TaxRate'}, );
    this.new_invoice.isTaxable = this.isTaxable;
    this.taxRate = parseFloat(this.taxRate);
    this.new_invoice.taxRate = this.taxRate;
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
